export const GET_BLOGS_REQUEST = "GET_BLOGS_REQUEST";
export const GET_BLOGS_SUCCESS = "GET_BLOGS_SUCCESS";
export const GET_BLOGS_FAILURE = "GET_BLOGS_FAILURE";

export const GET_SINGLE_BLOGS_REQUEST = "GET_SINGLE_BLOGS__REQUEST";
export const GET_SINGLE_BLOGS_SUCCESS = "GET_SINGLE_BLOGS__SUCCESS";
export const GET_SINGLE_BLOGS_FAILURE = "GET_SINGLE_BLOGS__FAILURE";

export const CREATE_REVIEW_REQUEST = "CREATE_REVIEW_REQUEST";
export const CREATE_REVIEW_SUCCESS = "CREATE_REVIEW_SUCCESS";
export const CREATE_REVIEW_FAILURE = "CREATE_REVIEW_FAILURE";

export const CREATE_BLOG_REQUEST = "CREATE_BLOG_REQUEST";
export const CREATE_BLOG_SUCCESS = "CREATE_BLOG_SUCCESS";
export const CREATE_BLOG_FAILURE = "CREATE_BLOG_FAILURE";

export const REACTION_REQUEST = "USER.REACTION_REQUEST";
export const REACTION_SUCCESS = "USER.BLOG.REACTION_SUCCESS";
export const REVIEW_REACTION_SUCCESS = "USER.REVIEW_REACTION_SUCCESS";
export const REACTION_FAILURE = "USER.REACTION_FAILURE";

export const UPDATE_BLOG_REQUEST = "UPDATE_BLOG_REQUEST";
export const UPDATE_BLOG_SUCCESS = "UPDATE_BLOG_SUCCESS";
export const UPDATE_BLOG_FAILURE = "UPDATE_BLOG_FAILURE";

export const DELETE_BLOG_REQUEST = "DELETE_BLOG_REQUEST";
export const DELETE_BLOG_SUCCESS = "DELETE_BLOG_SUCCESS";
export const DELETE_BLOG_FAILURE = "DELETE_BLOG_FAILURE";
